import { useEffect, useState } from 'react'

import { IColumnsType } from '../types'

export interface ISortedFieldOptionType<Data> {
  key: keyof Data | null
  direction: 'ascend' | 'descend'
}

export interface ISortedFieldReturnType<Data> {
  sortedField: ISortedFieldOptionType<Data>
  setSortedField: (options: ISortedFieldOptionType<Data>) => void
}

const useSortedField = <Data>(
  defaultSortedField: keyof Data | null,
  mergedBody: IColumnsType<Data>[],
  defaultSortingDirection: 'ascend' | 'descend' = 'descend',
): ISortedFieldReturnType<Data> => {
  const [sortedField, setSortedField] = useState<ISortedFieldOptionType<Data>>({
    key: defaultSortedField,
    direction: defaultSortingDirection,
  })

  useEffect(() => {
    const sortedKey = sortedField.key

    if (
      sortedKey &&
      sortedKey !== defaultSortedField &&
      !mergedBody.find(({ key }) => key === sortedKey)?.sorter
    )
      setSortedField({
        key: defaultSortedField,
        direction: 'descend',
      })
  }, [defaultSortedField, mergedBody, sortedField, setSortedField])

  return { sortedField, setSortedField }
}

export default useSortedField
